import {
  getBaseState,
  getEntityAdapterReducers,
  handleFulfilledAction,
  handleMultipleLoadingActions,
} from '@hwm/ui-lib';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { IAccountSettings } from '../../../../models/IAccountSettings';
import { EntityReducers } from '../../EntityReducers';
import { thunks } from './SettingsThunks';

const entityAdapter = createEntityAdapter<IAccountSettings>({});

export const MAX_NUM_OF_SITES_SELECT_ALL = 1000;

const slice = createSlice({
  name: EntityReducers.settings,
  initialState: {
    ...getBaseState(entityAdapter),
  },
  reducers: {
    ...getEntityAdapterReducers(entityAdapter),
  },
  extraReducers: (builder) => {
    handleMultipleLoadingActions([thunks.getSettings, thunks.saveSettings], builder);
    handleFulfilledAction(thunks.getSettings, builder, (state, payload) => {
      entityAdapter.upsertOne(state, payload);
    });
    handleFulfilledAction(thunks.saveSettings, builder, (state, payload) => {
      entityAdapter.upsertOne(state, payload);
    });
  },
});

export const settingsReducer = {
  slice,
  entityAdapter,
  thunks,
};
